import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function DigitalPrivateInfrastructureBasicInfoComponent ({handleInnerFormChange, selectedDigitalPrivateInfrastructure}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedDigitalPrivateInfrastructure?.Name}
          />
        <InputContainer

label="Service"
name="Service"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
    'Service',

  )
}}
type="text"
value={selectedDigitalPrivateInfrastructure?.Service}
/>
        <InputContainer

label="Type"
name="Type"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
    'Type',

  )
}}
type="text"
value={selectedDigitalPrivateInfrastructure?.Type}
/>
<InputContainer

    label="Cost"
    name="Cost"
    onValueChange={(event: any) => {
      handleInnerFormChange(
        event.target.value,
        'Cost',
    
      )
    }}
    type="number"
    value={selectedDigitalPrivateInfrastructure?.Cost}
/>
<InputContainer

    label="Enabled"
    name="IsEnabled"
    onValueChange={(event: any) => {
      handleInnerFormChange(
        event,
        'IsEnabled',
    
      )
    }}
    type="checkbox"
    value={selectedDigitalPrivateInfrastructure?.IsEnabled}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}